import { AvField, AvForm } from 'availity-reactstrap-validation';
import React, { Component, useEffect, useState } from 'react';
import {
  Card,
  CardBody,
  Col,
  Row,
  Container,
  FormGroup,
  Label,
  Input,
  CustomInput,
  Button,
} from 'reactstrap';
import useGet from '../../../helpers/hooks/useGet';
import toastr, { error } from 'toastr';
import useAttachement from '../../../helpers/hooks/useAttachments';
import usePost from '../../../helpers/hooks/usePost';
import { useHistory } from 'react-router-dom';
import { FixedScaleAxis } from 'chartist';
const CreateAnnouncement = (props) => {
  const history = useHistory();
  const [districts, , districtssLoading] = useGet('/districts', true);
  const [languages, , languagessLoading] = useGet('/languages', true);
  const [vegetables, , vegetablessLoading] = useGet('/vegetables', true);
  const [fieldAreas, , fieldAreassLoading] = useGet('/field-areas', true);

  const [publishType, setPublishType] = useState();
  const [announcementType, setAnnouncementType] = useState();
  const [selectedMedia, setSelectedMedia] = useState();
  const { upload, error, loading: imagesUploading, urls } = useAttachement();
  const [postAnnouncement, postedData, postingError, dataPosting] = usePost(
    '/announcements'
  );
  const [postOn, setPostOn] = useState(new Date());
  const handlePublishTypeChange = ({ target: { id } }) => {
    setPublishType(id);
  };
  const handleAnnouncementTypeChange = ({ target: { id } }) => {
    console.log(id);
    setAnnouncementType(id);
  };
  const handleFormSubmit = (event, errors, values) => {
    console.log(values);
    console.log(errors);
    if (errors.length > 0) {
      return toastr.warning('Please fix errors in the form');
    }
    if (!publishType) {
      return toastr.warning('Please fix errors in the form');
    }
    if (announcementType !== 'TEXT') {
      if (!selectedMedia) {
        return toastr.warning('Please fix errors in the form');
      }
    }
    if (publishType === 'schedule') {
      if (!postOn) {
        return toastr.warning('Please fix errors in the form');
      }
    }
    const obj = {
      ...values,
      sendInstant: publishType === 'instant',
      postOn: new Date(postOn).toISOString(),
      contentType: announcementType,
    };
    if (announcementType !== 'TEXT') {
      upload([selectedMedia]).then((_urls) => {
        postAnnouncement({ ...obj, content: _urls[0] });
      });
    } else {
      postAnnouncement({ ...obj });
    }
  };
  useEffect(() => {
    if (postingError) {
      console.log(postingError);
      toastr.error(postingError.error.message);
    }
  }, [postingError]);
  useEffect(() => {
    if (postedData) {
      toastr.success('Announcement has been created successfully');
      history.push('/baythak?tab=2');
    }
  }, [history, postedData]);
  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid>
          <AvForm className='needs-validation' onSubmit={handleFormSubmit}>
            <Row>
              <Col md={{ size: 10, offset: 1 }}>
                <Card>
                  <CardBody>
                    <FormGroup>
                      <Label htmlFor='name'>Name</Label>
                      <AvField
                        name='name'
                        placeholder='Name'
                        type='text'
                        errorMessage='Enter Name'
                        className='form-control'
                        validate={{ required: { value: true } }}
                        id='name'
                      />
                    </FormGroup>

                    <div className='mt-4 mt-lg-0'>
                      <h5 className='font-size-14 mb-4'>Announcement Type</h5>
                      <Row>
                        <div className='custom-control custom-radio mb-3 mr-2 ml-3'>
                          <Input
                            type='radio'
                            id='TEXT'
                            name='announcementType'
                            className='custom-control-input'
                            onChange={handleAnnouncementTypeChange}
                          />
                          <Label
                            className='custom-control-label'
                            htmlFor='TEXT'
                          >
                            Text
                          </Label>
                        </div>
                        <div className='custom-control custom-radio mb-3 mr-2'>
                          <Input
                            type='radio'
                            id='IMAGE'
                            name='announcementType'
                            className='custom-control-input'
                            onChange={handleAnnouncementTypeChange}
                          />
                          <Label
                            className='custom-control-label'
                            htmlFor='IMAGE'
                          >
                            Image
                          </Label>
                        </div>
                        <div className='custom-control custom-radio mb-3'>
                          <Input
                            type='radio'
                            id='VIDEO'
                            name='announcementType'
                            className='custom-control-input'
                            onChange={handleAnnouncementTypeChange}
                          />
                          <Label
                            className='custom-control-label'
                            htmlFor='VIDEO'
                          >
                            Video
                          </Label>
                        </div>
                      </Row>
                    </div>
                    {announcementType === 'TEXT' ? (
                      <FormGroup>
                        <Label>Enter Description</Label>
                        <AvField
                          type='textarea'
                          name='content'
                          validate={{ required: true }}
                        />
                      </FormGroup>
                    ) : (
                      announcementType && (
                        <>
                          {' '}
                          <FormGroup>
                            <Label>Additional Text</Label>
                            <AvField type='textarea' name='additionalText' />
                          </FormGroup>
                          <FormGroup>
                            <div className='custom-file'>
                              <CustomInput
                                type='file'
                                className='custom-file-input'
                                id='image'
                                accept={
                                  announcementType === 'IMAGE'
                                    ? 'image/*'
                                    : 'video/*'
                                }
                                onChange={(e) => {
                                  setSelectedMedia(e.target.files[0]);
                                }}
                              />
                              <Label
                                className='custom-file-label'
                                htmlFor='image'
                              >
                                {selectedMedia
                                  ? selectedMedia.name
                                  : 'Choose Media'}
                              </Label>
                            </div>
                          </FormGroup>
                        </>
                      )
                    )}
                    <FormGroup>
                      <Label>Where do you want to pubish?</Label>
                      <AvField
                        type='select'
                        name='districtIds'
                        multiple
                        validate={{ required: true }}
                      >
                        {districts?.map((x) => (
                          <option value={x.id}>{x.name}</option>
                        ))}
                      </AvField>
                    </FormGroup>

                    <FormGroup>
                      <Label>Farmers - Who Grow</Label>
                      <AvField
                        type='select'
                        name='vegetableIds'
                        multiple
                        validate={{ required: true }}
                      >
                        {vegetables?.map((x) => (
                          <option value={x.id}>{x.name}</option>
                        ))}
                      </AvField>
                    </FormGroup>
                    <FormGroup>
                      <Label>Farmers - Who Speak</Label>
                      <AvField
                        type='select'
                        name='languageIds'
                        multiple
                        validate={{ required: true }}
                      >
                        {languages?.map((x) => (
                          <option value={x.id}>{x.title}</option>
                        ))}
                      </AvField>
                    </FormGroup>
                    <FormGroup>
                      <Label>Farmers - Having Land Size</Label>
                      <AvField
                        type='select'
                        name='fieldAreaIds'
                        multiple
                        validate={{ required: true }}
                      >
                        {fieldAreas?.map((x) => (
                          <option value={x.id}>{x.name}</option>
                        ))}
                      </AvField>
                    </FormGroup>
                    <div>
                      <h5 className='font-size-14 mb-4'>
                        When do you want to publish?
                      </h5>
                      <FormGroup>
                        <div className='custom-control custom-radio mb-3'>
                          <Input
                            type='radio'
                            id='instant'
                            name='publishType'
                            onChange={handlePublishTypeChange}
                            className='custom-control-input'
                          />
                          <Label
                            className='custom-control-label'
                            htmlFor='instant'
                          >
                            Instant
                          </Label>
                        </div>
                        <div className='custom-control custom-radio mb-3'>
                          <Input
                            type='radio'
                            id='schedule'
                            name='publishType'
                            onChange={handlePublishTypeChange}
                            className='custom-control-input'
                          />
                          <Label
                            className='custom-control-label'
                            htmlFor='schedule'
                          >
                            Schedule
                          </Label>
                        </div>
                      </FormGroup>
                    </div>
                    {publishType === 'schedule' && (
                      <FormGroup>
                        <Input
                          className='form-control'
                          type='datetime-local'
                          defaultValue={new Date()}
                          min={new Date()}
                          onChange={({ target: { value } }) => setPostOn(value)}
                        />
                      </FormGroup>
                    )}
                  </CardBody>
                </Card>
                <div className='text-right mb-5'>
                  <Button
                    color='primary'
                    disabled={dataPosting || imagesUploading}
                  >
                    {dataPosting || imagesUploading
                      ? 'Saving...'
                      : 'Save and Publish'}
                  </Button>
                </div>
              </Col>
            </Row>
          </AvForm>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default CreateAnnouncement;
